import { Link } from "react-router-dom";

const announcements2025Array = [
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/Summer_Internship_2025_Flyer.pdf",
        title: "Summer Internship at IIT Tirupati - Click here",
       
        modal: false,        
   },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2511_Notification_JEA.pdf",
        title: "Notification for the position of Junior Executive Assistant (Outsourced Position)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2511_Notification_JEA.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2511_Application_Form_JEA.pdf",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Notification_CC_positions.pdf",
        title: "Notification for Various Positions in the CC Department (Outsourced Positions)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Notification_CC_positions.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2510_Application_Form.pdf",
        modal: false,        
    },
    {
             link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2509_Shortlisted_SEA.pdf",
             title: "Shortlisted candidates for the position of  Senior Executive Assistant (Accounts - Outsourced Position)",
            
             modal: false,        
        },
        {
                 link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2508_Shortlisted_JEA.pdf",
                 title: "Shortlisted candidates for the position of Junior Executive Assistant (Accounts - Outsourced Position)",
                
                 modal: false,        
             },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2505.pdf",
        title: "Selected candidate for the position of Program Administrator - Global Engagement, Alumni & Co-operate Relations - Outsourced Position",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Shortlisted_Rev_18.pdf",
        title: <>Revised shortlisted candidates for the position of Project Associate - Civil (02) & Environmental Manager cum Plant Operator (01) - Engineering Unit (Outsourced Position)." <br />
        *Note: Due to some administrative reasons, the date of the selection process is postponed to 24th Feb 2025.
        </>,
        
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25063_Notification_Electrician_cum_plumber.pdf",
        title: "Notification for the position of Electrician cum plumber (1) - Hostels (Outsourced Position)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25063_Notification_Electrician_cum_plumber.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25063_Application_Form_Electrician_cum_plumber.pdf",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25062_Notification_Caretaker.pdf",
        title: "Notification for the position of Caretaker (1) - Hostels (Outsourced Position)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25062_Notification_Caretaker.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSAT2024-25062_Application_Form_Caretaker.pdf",
        modal: false,        
    },

    {
        link: "/Project_Positions",
        title: "Advertisement for the Postdoctoral Fellow and Project Associate I - positions in the Department of Physics under CSRC",
        
        modal: false,        
    },

    {
        link: "/Project_Positions",
        title: "Advertisement for the various positions of Research Intern, Junior Research Fellow, Research Associate III, and Scientific Officer / Technical Engineer - positions in the Department of Physics under CSRC",
        
        modal: false,        
    },    
    
    {
        link: "/Interns_and_Apprentice",
        title: "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFPRECT-OS2024-2506_Selected_list.pdf",
        title: "Selected candidates for the position of Junior Executive Assistant - Outsourced Position",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2509_Senior_Executive_Assistant_Notification.pdf",
        title: "Notification for the position of Senior Executive Assistant (1) - Accounts Section (Outsourced Position)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2509_Senior_Executive_Assistant_Notification.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2509_Application_Form_for_Senior_Executive_Assistant.pdf",
        modal: false,        
    },
    {
        link: "/Project_Positions",
        title: "Advertisement for the Junior Research Fellow - 01 position in the Department of Civil and Environmental Engineering under CSRC",
        
        modal: false,        
    },
    {
        link: "/Project_Positions",
        title: "Advertisement for the Junior Research Fellow - 01 position in the Department of Mechanical and Chemical Engineering under CSRC",
        
        modal: false,        
    },
    {
        link: "/Project_Positions",
        title: "Advertisement for the Junior Research Fellow - 01 position in the Department of Mechanical Engineering under CSRC",
        
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Notification_Project_Associate_Environmental_Manager.pdf",
        title: "Notification for the position of Project Associate - Civil (02) & Environmental Manager cum Plant Operator (01) - Engineering Unit (Outsourced Position)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Notification_Project_Associate_Environmental_Manager.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Application_Form.pdf",
        modal: false,        
    },
    {
        link: "/Project_Positions",
        title: "Advertisement for the Project Lab Assistant - 01 position in the Department of Mechanical Engineering under CSRC",
        
        modal: false,        
    },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMRECT-OS2024-2505_Shortlisted_PA.pdf",
    //     title: "Shortlisted candidates for the position of Program Administrator for Global Engagement, Alumni and Corporate Relations - GAC Office (Outsourced Position).",
        
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMRECT-OS2024-2506_Shortlisted_JEA.pdf",
    //     title: "Shortlisted candidates for the position of Junior Executive Assistant (3) - Outsourced Position",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Notification.pdf",
    //     title: "Notification for the position of Junior Executive Assistant (2) - Accounts Section (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2507_Application_Form_JEA.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow - 01 position in the Department of Chemical and Mechanical Engineering under CSRC",
        
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2506_Junior_Executive_Notification.pdf",
    //     title: "Notification for the position of Junior Executive Assistant (3) - Outsourced Position",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2506_Junior_Executive_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTSTFMREC-OS2024-2506_Application_Form.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Interns_and_Apprentice",
    //     title: "Selected Candidates List for Library Information Assistant - Interns for Central Library",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2505.pdf",
    //     title: "Notification for the position of Program Administrator for Global Engagement, Alumni and Corporate Relations - Last date extended up to 06.01.2025. -  IAA Office (Outsourced Position).",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2505.pdf",
        
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Selected candidate list for the position of Project Officer - 01 position under CoE (SM & EVT), IIT Tirupati",
        
        
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Selected candidate list for the position of Project Officer - 01 position under CoE (SM & EVT), IIT Tirupati",
        
       
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Selected candidate list for the position of Assistant Manager - 01 position under CoE (SM & EVT), IIT Tirupati",
        
       
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Selected candidate list for the position of Project Manager - IPR (CSRC Section)",
       
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSAT2024-25010_Selection_List_Junior_Executive_Female.pdf",
    //     title: "Selected candidate list for the position of Junior Executive Female (01 position) -  HoME Office (Outsourced Position)",
       
    //     modal: false,        
    // },
    
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Research Assistant Post - 01 position in the Department of Humanities and Social Sciences under CSRC",
        
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2503_Selected_List.pdf",
    //     title: "Selected Candidates list for the position of Project Associate - 02 positions in the Department of Civil and Electrical Engineering (Outsourced Position)",
       
       
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow Post - 02 position in the Department of Computer Science and Engineering under CSRC",
        
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Project Associate Post - 02 position in the Department of Computer Science and Engineerin under CSRC",
       
    //     modal: false,        
    // },
    // {
        
    //     link: "https://files.iittp.ac.in/pdfs/Orientation/2025/Orientation_MS_PhD_Jan_Jun_25.pdf",
    //     title: "Orientation Program for M.S.(R) / Ph.D. Jan-2025 Batch on December 16, 2024 - Click here",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFPRECT-OS2024-2502_Selected_List.pdf",
    //     title: "Selected candidates list for the position of Junior Executive Assistant - Academics Section (Outsourced Position)",
    //     modal: false,        
    // },
    // {
    //     link: "/msphd-admissions",
    //     title: "List of Selected Candidates for the M.S.(R) and Ph.D. September 2024 Admissions across Various Departments.",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSAT2024-25010_Shortlisted_candidates.pdf",
    //     title: "Shortlisted candidates list for the position of Junior Executive Female (01 position) -  HoME Office (Outsourced Position)",
       
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Shortlisted candidates list for the position of Project Officer - 01 position under CoE (SM & EVT), IIT Tirupati",
        
        
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Shortlisted candidates list for the position of Project Officer - 01 position under CoE (SM & EVT), IIT Tirupati",
        
       
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Shortlisted candidates list for the position of Assistant Manager - 01 position under CoE (SM & EVT), IIT Tirupati",
        
       
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Research Assistant / Project Assistant - 01 position in the Department of Chemical, Civil and Mechanical Engineering under CSRC (2023-24 #36",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2536.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Senior Research Fellow Post - 01 position in the Department of Civil & Environmental Engineering under CSRC (2023-24 #35)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2535.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Scientific Administrative Assistant / Field worker post - 01 position in the Department of Civil & Environmental Engineering and Department of Humanities and Social Sciences under CSRC (2023-24 #34)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2534.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow - 01 position in the Department of Civil & Environmental Engineering under CSRC (2023-24 #33)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2533.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow - 02 position in the Department of Civil & Environmental Engineering under CSRC (2023-24 #32)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2532.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2504_Shortlisted.pdf",
    //     title: "Shortlisted Candidates list for the position of Environmental Manager cum Plant Operator (Outsourced Position)",
       
       
    // },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2503_Shortlisted.pdf",
    //     title: "Shortlisted Candidates list for the position of Project Associate - 02 positions in the Department of Civil and Electrical Engineering (Outsourced Position)",
       
       
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Field Investigator - 01 position in the Department of Humanities and Social Sciences under CSRC (2023-24 #31)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2531.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Research Assistant - 01 position in the Department of Humanities and Social Sciences under CSRC (2023-24 #30)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2530.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Project Assistant - 01 position in the Department of Chemical and Mechanical Engineering under CSRC (2023-24 #29)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2529.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Interns_and_Apprentice",
    //     title: "Provisionally Shortlisted and Not Shortlisted Candidates List for Library Information Assistant - Interns for Central Library",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFPRECT-OS2024-2502_11_11_24_Shortlisted.pdf",
    //     title: "Shortlisted candidates list for the position of Junior Executive Assistant - Academics Section (Outsourced Position)",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSAT2024-25010_Notification.pdf",
    //     title: "Notification for the position of Junior Executive Female (01 position) -  HoME Office (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSAT2024-25010_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSAT2024-25010_Application.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Selected_List.pdf",
    //     title: "Selected Candidates List For Various Positions of CC Department (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "/msphd-admissions",
    //     title: "List of provisionally shortlisted candidates for Written Test/Interview - M.S(R) & Ph.D - September 2024 Notification. - Click here",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2504_Notification.pdf",
    //     title: "Notification for the position of Environmental Manager cum Plant Operator - 01 position (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2504_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2504_Application.pdf",
    //     modal: false,        
    // },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTSTFMREC-OS2024-2503_Notification.pdf",
    //     title: "Notification for the position of Project Associate - 02 positions in the Department of Civil and Electrical Engineering (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTSTFMREC-OS2024-2503_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTSTFMREC-OS2024-2503_Application_Form.pdf",
    //     modal: false,        
    // },

    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Project Associate / Senior Project Associate - 01 position in the Department of Chemical Engineering under CSRC (2023-24 #28)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2528.pdf",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Project Assistant - 01 position in the Department of Chemical Engineering under CSRC (2023-24 #27)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2527.pdf",
    //     modal: false,        
    // },

    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow (JRF) - 02 positions in the Department of Mechanical Engineering under CSRC (2023-24 #26)",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2526.pdf",
    //     modal: false,        
    // },

    // {
    //     link: "/Project_Positions",
    //     title: "Notification for the position of Project Officer - 01 position under CoE (SM & EVT), IIT Tirupati",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2523.pdf",
    //     // appLink : "https://forms.gle/JKbJQT4mM2pZURnL8",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Notification for the position of Project Officer - 01 position under CoE (SM & EVT), IIT Tirupati",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2525.pdf",
    //     // appLink : "https://forms.gle/JKbJQT4mM2pZURnL8",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Notification for the position of Assistant Manager - 01 position under CoE (SM & EVT), IIT Tirupati",
    //     // notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524.pdf",
    //     // appLink : "https://forms.gle/5KR7FbfpH6WQke5KA",
    //     modal: false,        
    // },
    
    
    // {
    //     link: "/Interns_and_Apprentice",
    //     title: "Notification for the position of Library Information Assistant - Interns for Central Library",
    //     notifyLink: "/Interns_and_Apprentice",
    //     // appLink : "https://docs.google.com/forms/d/e/1FAIpQLSenRZrFqoIJObPiEgNndFDLmbtpIFFvccMtxw_qgsYxSx3lrA/viewform",
    //     modal: false,        
    // },


    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2502_Notification.pdf",
    //     title: "Notification for the position of Junior Executive Assistant - Academics Section (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2502_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMREC-OS2024-2502_Application_Form.pdf",
    //     modal: false,        
    // },
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Selected_list_Grounds_Man_14_10_2024.pdf",
    //     title: "Selected candidate list for the position of Grounds Man (Outsourced Position)",
    //     modal: false,
    // },
    // // {
    // //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTLIB-INTERNAdvt.2024-2501_Notification_Library_Information_Assistant_Interns.pdf",
    // //     title: "Notification for the  position of Library Information Assistant - Interns for Central Library",
    // //     modal: false,        
    // // },
   
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow (JRF) - 01 position in the Department of Mechanical Engineering under CSRC (2023-24 #22)",
    //     modal: false,        
    // },
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_for_Groundsman_27_9_24.pdf",
    //     title: "Walk-in-interview for the position of Grounds Man (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_for_Groundsman_27_9_24.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Application_Form_Grounds_Man_27_9_24.pdf",
    //     modal: false,
    // },
    
    // {
    //     link: "/admissions",
    //     title: "Deadline for submission of online applications for M.S.(R) and Ph.D. admissions is extended until 17th October, 2024. - Click here",
    //     modal: false,
    // },
    // {
    //     link: "/msphd-admissions",
    //     title: "Syllabus for M.S.(R) & Ph.D Admissions (September 2024)  - Click here",
    //     modal: false,
    // },

    // {
    //     link: "/ms-phd-international",
    //     title: "Online applications open for M.S.(R) & Ph.D International Admissions - Click here",
    //     modal: false,
    // },
    // {
    //     link: "/recruitment",
    //     title: "Advertisement for Non-Teaching Staff Positions (Regular)",
    //     modal: false,
    // },
    
    // {
    //     link: "/m-sc-admission",
    //     title: "M.Sc. Admissions : JAM-2025 application portal (JOAPS) open now",
    //     modal: false,
    // },
    // {
    //     link: "https://www.iittp.ac.in/institute-scholarships",
    //     title: (<>Applications Invited for Institute Scholarships for the Academic Year 2024-25 (Last Date: 25-09-2024)<br/><br/></>),
    //     eligibilityLink: "https://www.iittp.ac.in/institute-scholarships",
    //     modal: false,
    // },
    // {
    //     link: "https://scholarships.gov.in/Students",
    //     title:  (<>National Scholarship Portal Invites Applications For Various Scholarships<br/><br/></>),
    //     eligibilityLink: "https://scholarships.gov.in/Students",
    //     schemeLink: "https://scholarships.gov.in/All-Scholarships",
    //     userLink: "https://files.iittp.ac.in/pdfs/announcements/2024/OnlineDemoSession_on_NSP2_08Aug2024.pdf",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSTFMRECT-OS202401_Selected_list.pdf",
    //     title: "Selected candidate list for the position of Junior Executive Assistant - Admin for KV school, IIT Tirupati (Outsourced Position)",
    //     modal: false,
    // },
    // {
    //     link: "https://scholarships.gov.in/Students",
    //     title: (<>National Fellowship And Scholarship For Higher Education Of St Students - Scholarship (Formally Top Class Education For Schedule Tribe Students) <br/><br/> (Last Date: 31-10-2024)<br/><br/></>),
    //     eligibilityLink: "https://scholarships.gov.in/Students",
    //     guideLink: "https://scholarships.gov.in/public/schemeGuidelines/tribalfellowshipguideline.pdf",
    //     userLink: "https://files.iittp.ac.in/pdfs/announcements/2024/OnlineDemoSession_on_NSP2_08Aug2024.pdf",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_CC_Shortlisted_24_9_2024.pdf",
    //     title: "Shortlisted Candidates List For Various Positions of CC Department (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSPORTS02COACH_AD2024_Part_Time_Coaches_Selected_Canditate_List.pdf",
    //     title: "Selected Candidate List - Part-Time Coaches (HoME Office)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/EE_ProjectOfficer_Selected_list.pdf",
    //     title: "Selected candidate for the position of Project Officer (Civil) - Engineering Unit ",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Selection_List-Placement_Executive_18_9_24.pdf",
    //     title: "Selected Candidate List - Placement Executive (HoME Office)",
    //     modal: false,
    // },
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Selection_List_Students_Coordinator.pdf",
    //     title: "Selected Candidate List - Students’ Coordinator (HoME Office)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS202024_Selected_List.pdf",
    //     title: "Selected Candidate List - Project Assistant - EE Department (Outsourced Positions)",
    //     modal: false,
    // },
   
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow (JRF) - 01 position in the Department of Mechanical Engineering under CSRC (2023-24 #21)",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_For_Placement_Executive_2_9_24.pdf",
    //     title: "Walk-in-interview for the position of Placement Executive (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_For_Placement_Executive_2_9_24.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Application_Form-Placement_Executive_2_9_24.pdf",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS172024_Selected_List.pdf",
    //     title: "Selected Candidate List - Health Centre Assistant (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2519_Exnd.pdf",
    //     title:(<> Advertisement for the Junior Research Fellow (JRF) - 02 positions in the Department of Computer Science and Engineering under CSRC (2023-24 #19) <br/><br/> (Last Date Extended: 11-09-2024)<br/><br/></>),
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_for_Students_Coordinator.pdf",
    //     title: "Walk-in-interview for the position of Students’ Coordinator (Outsourced Position)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_for_Students_Coordinator.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Student_Coordinator_Application_Form.pdf",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS192024_Shortlisted_candidates_EU.pdf",
    //     title: "Shortlisted Candidates List - Project Officer (Civil) & Project Officer (Architect) (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS202024_Shortlisted_candidates_PA_EE.pdf",
    //     title: "Shortlisted Candidates List - Project Assistant - Electrical Engineering Department (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTSPORTS02COACH_AD2024_Coaches_Re-Notification.pdf",
    //     title: "Notification for Engagement of Part-Time / Hourly Basis Coaches (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Shortlisted_Candidates.pdf",
    //     title: "Shortlisted Candidates List - Health Centre Assistant (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Project Associate - 01 position in the Department of Computer Science and Engineering under CSRC (2023-24 #20)",
    //     modal: false,        
    // },
    

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS162024_Selected_List.pdf",
    //     title: "Selected Candidates List – Junior Executive - Academics Section (Outsourced Positions)",
    //     modal: false,
    // },

    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Mechanical Engineering under CSRC (2023-24 #18)",
    //     modal: false,        
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Chemical and Engineering under CSRC (2023-24 #17)",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP_RECT-OS202024_Notification.pdf",
    //     title: "Notification for Outsourced Position of Project Assistant for Electrical Engineering Department - #FESS/IITTP/RECT-OS/20/2024",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP_RECT-OS202024_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP_RECT-OS202024_Application.pdf",
    //     modal: false,
    // },

    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for the post of Project Manager (Innovation, Incubation, IPR, Start up and Industrial relations) at Centre for Sponsored Research and Consultancy (CSRC)- IIT Tirupati.",
    //     modal: false,        
    // },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS192024_Notification.pdf",
    //     title: (<>Notification for Outsourced Position of Project Officer (Civil & Architect) - #ITTP/FESS/RECT-OS/19/2024 <br/><br/> (Last Date: 16-08-2024)<br/><br/></>),
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS192024_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS192024_Application_Form.pdf",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC_2023-24_16.pdf",
    //     title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Computer Science and Engineering under CSRC (2023-24 #16)",
    //     modal: false,        
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS182024_Notification_CC.pdf",
    //     title: "Notification for Outsourced Position of Project Officer, Project Associate, Project Assistant - Computer Center Department",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS182024_Notification_CC.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS182024_Application_Form_CC.pdf",
    //     modal: false,
    // },
   
    // {
    //     link: "/information_for_btech_students",
    //     title: "Information for B.Tech 2024 Batch Students - Click here for more details",
    //     modal: false,
    // },
    // {
        
    //     link: "https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_MS_PhD_Jul_24.pdf",
    //     title: "Orientation Program for M.S.(R) / Ph.D. Scholars on July 25-26, 2024 - Click here",
    //     modal: false,
    // },
    // {
        
    //     link: "https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_Mtech_Msc_MPP_2024.pdf",
    //     title: "Orientation Program for M.Tech / M.Sc / MPP on July 26, 2024 - Click here",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS162024_Shortlisted_candidates_Junior_Executive.pdf",
    //     title: "Shortlisted Candidates List - Junior Executive - Academics (Outsourced Positions)",
    //     modal: false,
    // },
    // {
        
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2415.pdf",
    //     title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Mechanical Engineering under CSRC",
    //     modal: false,
    // },
    // {
        
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2413.pdf",
    //     title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Electrical Engineering under CSRC",
    //     modal: false,
    // },
    // {
        
    //     link: "/Project_Positions",
    //     title: "Advertisement for the Project Assistant Level 1 position in the Department of Computer Science and Engineering under CSRC",
    //     modal: false,
    // },
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITT_SPORTS_02_COACH.AD_2024.pdf",
    //     title: "Notification for Engagement of Part-Time / Hourly Basis Coaches",
    //     modal: false,
    // },
    // {
        
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/CSRC_23-24_12.pdf",
    //     title: "Advertisement for the post of Project Engineer in the Department of Electrical Engineering under CSRC",
    //     modal: false,
    // },
    // {
        
    //     link: "/Project_Positions",
    //     title: "Advertisement for the post of Project Associate in the Department of Electrical Engineering under CSRC",
    //     modal: false,
    // },
    // {
    //     link: "/convocation",
    //     title: "6th Convocation will be held on 21.07.2024 (Sunday) at IIT Tirupati campus - Click here for more details",
    //     modal: true,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Notification.pdf",
    //     title: "Notification for Outsourced Position – Health Centre Assistant",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Application_Form.pdf",
    //     modal: false,
    // },
    // {
    //     link: "/kvsiittcampus",
    //     title: "Walk-in-interview for part-time contractual teacher posts in KV School, IIT Tirupati campus - Click here",
    //     modal: false,
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Physics",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2409_27_6_24.pdf",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Civil and Environmental Engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Notification.pdf",
    //     title: "Notification for Outsourced Position – Junior Executive - Academics",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS162024_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS162024_Application_Form.pdf",
    //     modal: false,
    // },
   
    // {
    //     link: "/kvsiittcampus",
    //     title: "Admissions for the Vacant Seats in KV IIT Tirupati Campus for the Session 2024-2025",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS132024_Selected_Candidates_New.pdf",
    //     title: "Selected Candidates List – Yoga Instructor (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "/kvsiittcampus",
    //     title: "Provisionally selected list of candidates for appointment of Contractual Teachers for 2024-2025",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2408.pdf",
    //     title: "Advertisement for Project Assistant-I position in the Department of Chemical Engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS142024_Selected_List_Project_Assitant-Horticulture.pdf",
    //     title: "Selected Candidates List – Project Assistant (Horticulture - Outsourced Positions).",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Nursing_Practioner_Selected_List.pdf",
    //     title: "Selected Candidates List - Nursing Practitioner (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "/openhouse",
    //     title: "Open House - An Interactive Session for Prospective Students 2024",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2023-2407.pdf",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemistry and Chemical Engineering",
    //     modal: false,
    // },
    // {
    //     link: "/msphd-admissions",
    //     title: "Selected Candidates List for Master of Public Policy (MPP) - Click here",
    //     modal: false,
    // },
               
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering",
    //     modal: false,
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Humanities and Social Sciences",
    //     modal: false,
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Mechanical Engineering",
    //     modal: false,
    // },
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/msphd/admissions/2024/IITTP_2024-25_M.TechSponsored.pdf",
    //     title: "Selected Candidates List for M.Tech program under the Sponsored Category - Click here",
    //     modal: false,
    // },
    // {
    //     link: "/msphd-admissions",
    //     title: "Selected Candidates List for M.S.(Research) and Ph.D. Admissions July 2024 - Click here",
    //     modal: false,
    // },
    // {
    //     link: "/kvsiittcampus",
    //     title: "Walk-in-interview for part-time contractual teacher posts in KV School, IIT Tirupati campus - Click here",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS142024_Shortlisted_Candidates.pdf",
    //     title: "Shortlisted Candidates List – Project Assistant (Horticulture - Outsourced Positions). Due to Administrative Reasons, Project Assistant - Horticulture exam was rescheduled on 10-06-2024",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Shortlisted_NURSING_PRACTITIONER.pdf",
    //     title: "Shortlisted Candidates List - Nursing Practitioner (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS132024_Shortlisted_Candidates_New.pdf",
    //     title: "Shortlisted Candidates List – Yoga Instructor (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Notification.pdf",
    //     title: "Notification for Outsourced Position – Nursing Practitioner (Health Centre)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Notification.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Application_Form.docx",
    //     modal: false,
    // },
    // {
    //     link: "/kvsiittcampus",
    //     title: "Provisionally Selected List of Candidates for Admissions during 2024-2025 in KV IITT - Click here",
    //     modal: false,
    // },
   
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_FESSIITTPRECT-OS142024.pdf",
    //     title: "Notification for Outsourced Position – Project Assistant (Horticulture)",
    //     notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_FESSIITTPRECT-OS142024.pdf",
    //     appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Application_Form_FESSIITTPRECT-OS142024.docx",
    //     modal: false,
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Summer_Internship_Results.pdf",
    //     title: "Summer Internships Selected Candidates List - Click here",
    //     modal: false,
    // },

    // {
    //     link: "/m-tech-international",
    //     title: "M.Tech International Admissions 2024 are now open - Click here",
    //     modal: false,
    // },
    
   
   
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Last date extended up to 1st May, 2024",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS112024_Result-Nursing_Practitioner.pdf",
    //     title: "Selected Candidates List – Nursing Practitioner & Ward Assistant (Health Centre)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS122024_Result-MSA.pdf",
    //     title: "Selected Candidates List – Multi Skilled Assistant (Outsourced Positions)",
    //     notifyLink: "#",
    //     appLink: "#",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS072024_Selected_List-Academics.pdf",
    //     title: "Selected Candidates List – Junior Executive  - Academics (Outsourced Positions)",
    //     modal: false,
    // },
   
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Summer_Internship_2024_Corrigendum.pdf",
    //     title: "SUMMER INTERNSHIPS CORRIGENDUM - Click here",
    //     modal: false,
    // },
    // {
    //     link: "/kvsiittcampus",
    //     title: "KVS, IITT Campus Admissions 2024-25 - Click here",
    //     modal: false,
    // },
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification&Application_FESSIITTPRECT-OS132024.pdf",
    //     title: "Notification for Outsourced Position - Yoga Instructor (Part-time)",
    //     modal: false,
    // },
    // {
    //     link: "/admissions",
    //     title: "M. Tech. and MPP Admissions 2024 are now open - Click here",
    //     modal: false,
    // },
    
    // {
    //     link: "/recruitment",
    //     title: "Advertisement for various Non- Teaching Staff Positions(Regular)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS122024_Shortlisted_Candidates.pdf",
    //     title: "Shortlisted Candidates List – Multi Skilled Assistant (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS112024_Shortlisted_Candidates.pdf",
    //     title: "Shortlisted Candidates List – Nursing Practitioner & Ward Assistant (Health Centre)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPRECT-OS072023_Short_listed_Candidates.pdf",
    //     title: "Shortlisted Candidates List – Junior Executive, Academics (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "/Project_Positions",
    //     title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC-2023-24_29.pdf",
    //     title: "Advertisement for JRF position in the Department of Chemistry/Chemical engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/announcements/2024/FESSIITTP_RECT-OS112024_Notification.pdf",
    //     title: "Notification for Outsourced Position - Nursing Practitioner and Ward Assistant",
    //     modal: false,
    // },

    // {
    //     link: "https://files.iittp.ac.in/announcements/2024/FESSIITTP RECT-OS122024_Notification.pdf",
    //     title: "Notification for Outsourced Position - Multi Skilled Assistant", 
    //     modal: false,
    // },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC-2023-24_31.pdf",
    //     title: "Advertisement for Project Assistant position in the Department of Computer Science and Engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC-2023-24_30.pdf",
    //     title: "Advertisement for SRF position in the Department of Computer Science and Engineering",
    //     modal: false,
    // },
    // {
    //     link: "/admissions",
    //     title: "Online applications open for M.S.(R) & Ph.D - July 2024 - Click here",
    //     modal: false,
    // },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2427.pdf",
    //     title: "Advertisement for JRF/Project Staff Position",
    //     modal: false,
    // },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS102024_Selected_List.pdf",
    //     title: "Selected Candidate List - Hindi Typist cum Assistant (Outsourced Positions)",
    //     modal: false,
    // },

    //  {
    //      link: "https://files.iittp.ac.in/pdfs/announcements/2024/Internship_Notification_2024.pdf",
    //     title: "Notification for the Summer Internship (15th May to 14th July 2024) 2024 - Extension of online applications for summer internships upto 3rd april 2024, 5.00 pm.",
    //      modal: false,
    //  },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS092024_Result-Physiotherapist.pdf",
    //     title: "Selected Candidate List - Physiotherapist(Outsourced Positions) ",
    //     modal: false,
    // },

    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2426.pdf",
    //     title: "Advertisement for the Position of Junior Research Fellow - Department of Chemical Engineering and Mechanical Engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS102024_Short%20listed_Candidates%20-%20Hindi_Typis_cum_Assistant.pdf",
    //     title: "Shortlisted Candidates List - Hindi Typist cum Assistant (Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/IRES-2024_Indian_Student_Brochure.pdf",
    //     title: "USA-India International Research Experience for Students (IRES) - Indian Applicants",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2425.pdf",
    //     title: "Advertisement for the Position of Junior Research Fellow - Department of Physics (Last date extended up to 8th March, 2024)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP%20RECT-OS092024_Short%20listed_Candidates_Physiotherapist.pdf",
    //     title: "Shortlisted Candidates List - Physiotherapist(Outsourced Positions)",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/announcements#OP_HTA_2_9",
    //     title: "Notification for Outsourced Position - Hindi Typist cum Assistant",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2424.pdf",
    //     title: "Advertisement for the Positions of Junior Research Fellow - SERB Sponsored Project under CRG",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP%20RECT-OS082023_Selected_List-EU.pdf",
    //     title: "Selected Candidates List - Engineering Unit (Outsourced Positions)",
    //     modal: false,
    // },
    
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2418.pdf",
    //     title: "Advertisement for the Positions of Junior Research Fellow - Department of Electrical Engineering",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2422.pdf",
    //     title: "Advertisement for the Positions of Junior Research Fellow",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/announcements#OPT_AD_24_01",
    //     title: "Notification for Outsourced Positions - Physiotherapist",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt.%20IITTCCE2022-2321.pdf",
    //     title: "Advertisement for the post of Project Manager at CCE",
    //     modal: false,
    // },
    // {
    //     link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt%20IITTCSRC2023-2420.pdf",
    //     title: "Advertisement for the post of Project Associate in a time bound DTH Swayam Prabha Project. (Last date extended up to 31st January, 2024)",
    //     modal: false,
    // }

];

export default announcements2025Array;
